import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';

export default function ArticlesPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '久久插技术文章 —— 插接技术洞察与应用指南',
    description: '久久插技术文章中心，涵盖选型指南、技术解析、维护保养、行业趋势和应用案例，为您提供专业的插接件技术知识。',
    url: 'https://www.jiujiucha.com/articles',
  };

  return (
    <>
      <SEOHead
        title="久久插技术文章 —— 插接技术洞察与应用指南 | 久久插稳固连接"
        description="久久插技术文章中心：选型指南、防松脱技术解析、工业4.0插接趋势、维护保养指南、防水防护等级详解、轨道交通应用案例。专业插接技术知识分享平台。"
        keywords="插接技术文章,插接件选型指南,防松脱技术,插接件维护,工业插接件知识,久久插技术"
        canonicalUrl="https://www.jiujiucha.com/articles"
        schema={schema}
      />

      <Navbar />

      <main className="pt-16 md:pt-18">
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '技术文章' },
              ]}
            />
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mt-4 mb-3">
              技术文章
            </h1>
            <p className="text-foreground-600 text-sm md:text-base max-w-2xl">
              久久插技术团队倾心打造的专业内容平台，从选型到维护，从技术原理到行业趋势，为您提供全方位的插接技术知识。
            </p>
          </div>
        </div>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
              {articles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/articles/${article.slug}`}
                  className="group bg-background-50 rounded-xl border border-background-200/60 hover:border-accent-300/50 overflow-hidden transition-all duration-300 flex flex-col"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5 md:p-6 flex flex-col flex-1">
                    <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3 flex-wrap">
                      <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                        {article.category}
                      </span>
                      <span>{article.date}</span>
                      <span>·</span>
                      <span>{article.readTime}</span>
                    </div>
                    <h2 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4 flex-1">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-2 flex-wrap">
                      {article.tags.slice(0, 3).map((tag) => (
                        <span
                          key={tag}
                          className="px-2 py-0.5 text-xs rounded bg-background-100 text-foreground-500"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}